import {
  format,
  differenceInMinutes,
  differenceInHours,
  differenceInDays,
} from "date-fns";
import { ptBR } from "date-fns/locale";

export function getDate(templateFormat: string, date: string | Date) {
  let tempDate = date;
  if (typeof date === "string") {
    tempDate = date && date.includes("Z") ? date.replace("Z", "") : date;
  }

  const newDate = format(new Date(tempDate), templateFormat); //.format(format);

  if (newDate === "Data inválida") {
    return null;
  }

  return newDate;
}

export function difference(date: string) {
  const newDate =
    date && date.includes("Z") ? date.replace("Z", "") : new Date();
  const now = new Date();
  const createdDate = new Date(newDate);

  let diff = differenceInMinutes(now, new Date(createdDate));

  if (diff === 0) {
    return "Agora";
  } else if (diff > 0 && diff < 60) {
    return `${diff} min`;
  } else {
    diff = differenceInHours(now, new Date(createdDate));
    if (diff < 24) {
      return `${diff} h`;
    } else {
      diff = differenceInDays(now, new Date(createdDate));
      if (diff < 7) {
        return `${diff} d`;
      } else {
        return `${format(new Date(createdDate), "d 'de' MMMM',' yyyy", {
          locale: ptBR,
        })}`;
      }
    }
  }
}
